
import { Vue, Component, Prop } from "vue-property-decorator";
import { User } from "@/generated/graphql";
import Roles from "@/entities/Roles";

@Component
export default class EditButton extends Vue {
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  
  get isContractor(): boolean {
    return this.currentUser.role === Roles.CONTRACTOR;
  }
}
